import { useCallback, useEffect, useRef } from 'react'

export const useSharedLoginSession = () => {
  const sessionTick = useRef(null)

  const startSessionTick = useCallback(() => {
    sessionStorage.setItem('keepLoggedIn', 'true')
    localStorage.setItem('sessionTick', Date.now().toString())
    sessionTick.current = setInterval(() => {
      localStorage.setItem('sessionTick', Date.now().toString())
    }, 1000)
  }, [])

  const isActiveSession = useCallback(() => {
    const lastTick = localStorage.getItem('sessionTick')
    const keepLoggedIn = sessionStorage.getItem('keepLoggedIn') === 'true'
    const currentTime = Date.now()
    const sessionDuration = currentTime - +(lastTick || 0)
    return Boolean(sessionDuration < 1.5 * 1000) || keepLoggedIn
  }, [])

  const stopSessionTick = useCallback(() => {
    if (sessionTick.current) {
      clearInterval(sessionTick.current)
      sessionTick.current = null
    }
  }, [])

  const clearSessionTick = useCallback(() => {
    sessionStorage.removeItem('keepLoggedIn')
    stopSessionTick()
  }, [stopSessionTick])

  useEffect(() => {
    if (isActiveSession()) startSessionTick()
    return () => stopSessionTick()
  }, [startSessionTick, stopSessionTick, isActiveSession])

  return { startSessionTick, clearSessionTick, isActiveSession }
}
